import { Vue, Watch, Prop } from 'vue-property-decorator'
import { Module } from '@/models/Module'
import { ModuleDataItem } from '@/models/ModuleDataItem'
import { ModuleData } from '@/models/ModuleData'

export default class ModuleBase extends Vue {
	// protected module: Module = this.$store.getters.currentModule
	@Prop({ default: null }) protected submodule!: string
	protected sub: Module = new Module()
	protected subData: ModuleData = new ModuleData()
	private name: string = ''

	get module() {
		if (this.submodule) {
			return this.sub
		}
		return this.$store.getters.currentModule
	}

	get data() {
		if (this.submodule) {
			return this.subData
		}
		return this.$store.getters.moduleData
	}

	@Watch('$route.params.name', { immediate: true })
	private onNameChange(val: string) {
		this.name = this.$route.params.name
		if (this.submodule) {
			this.setSubModule()
			return
		}
		// Don't fetch if within same module
		if (this.name === this.module.name) {
			return
		}
		const id = this.$store.getters.moduleId(this.name)
		// The route doesn't exist
		if (!id) {
			// TODO: Handle error routing here.
			return
		}
		this.$store.dispatch('currentModule', id).then().catch(() => {
			this.$toasted.error('Failed to get app data.')
		})
		this.$store.dispatch('moduleData', this.name).then().catch(() => {
			this.$toasted.error('Failed to get app data.')
		})
	}

	private setSubModule() {
		const modules = this.$store.getters.modules
		const found = modules.find((item: Module) => item.class_name === this.submodule)
		this.sub.set('id', found.id)
		this.sub.fetch().then(() => console.log(this.sub))
		.catch(() => this.$toasted.error('Failed to get sub data.'))
		this.subData.set('name', found.name)
		this.subData.fetch().then(() => console.log(this.subData))
		.catch(() => this.$toasted.error('Failed to get sub data.'))
	}
}
